
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C11.1716 4 10.5 4.67157 10.5 5.5V9C10.5 9.82843 11.1716 10.5 12 10.5C12.8284 10.5 13.5 9.82843 13.5 9V5.5C13.5 4.67157 12.8284 4 12 4ZM4 13C4 9.64266 6.06817 6.76833 9 5.58156V9C9 10.6569 10.3431 12 12 12C13.6569 12 15 10.6569 15 9V5.58156C17.4647 6.57923 19.319 8.76949 19.8473 11.4368C19.1193 11.1547 18.3277 11 17.5 11C13.9101 11 11 13.9101 11 17.5C11 18.7886 11.375 19.9897 12.0218 21L12 21C7.58172 21 4 17.4183 4 13ZM18.5303 13.4697L18 12.9393L17.4697 13.4697L15.4697 15.4697L16.5303 16.5303L17.25 15.8107V19H18.75V15.8107L19.4697 16.5303L20.5303 15.4697L18.5303 13.4697ZM13.25 17V21V21.75H14H22H22.75V21V17H21.25V20.25H14.75V17H13.25Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowStartExportFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
